import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/cadastro/CadastroOportunidadeClient.tsx");
